import DateRangeSelect from "shared/input/DateRangeSelect";
import PropTypes from "prop-types";

/**
 * A React component representing a date range field.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.input - The input object containing the current value and onChange function.
 * @param {...rest} - Any additional props that can be passed to the DateRangeSelect component.
 * @returns {ReactElement} - The rendered DateRangeField component.
 */
export const DateRangeField = ({input, ...rest}) => (
  <DateRangeSelect
    {...rest}
    initialTimeInterval={input.value}
    onChange={input.onChange}
  />
);
DateRangeField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired
  }).isRequired
};
